import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { actions } from "../../../../store/modules";
import i18n from "../../../../plugins/i18n/i18n";
import moment from "moment";
import { Col, Row, List, Card, Spin, Modal, notification as Notification, Empty, Badge } from 'antd';
import { ExclamationCircleOutlined, CarOutlined } from '@ant-design/icons';
import { errorMessageNotification, isMobile } from "../../../../helpers";

const { confirm } = Modal;

const type = "pendingcostapprovaltrips";
const typeArchive = "trip/archivecostapprovaltrips";
let searchTimeout = null;

class TripApprovalList extends Component {

    constructor(props) {
        super(props);
        this.endpoint = { keyOne: type };
        this.endpointArchive = { keyOne: typeArchive };
        this.state = {
            isResponsive: false,
            dataActives: [],
            dataArchives: [],
            totalActives: 0,
            totalArchives: 0,
            loadings: {
                data: false
            },
            hasMore: true
        };
        this.filter = {
            page: 1,
            pagesize: 90,
            query: "",
            sort: "departureDate-desc"
        }
    }

    componentWillMount() {
        if (isMobile()) {
            this.setState({
                isResponsive: true,
            });
        }

        this.getData();
        this.getDataArchive();

        this.props.dispatch(actions.auth.getAccount());

    }

    getData = () => {

        let { loadings } = this.state;
        loadings.data = true;

        this.setState({ loadings });

        this.props.dispatch(actions.definitions.getData({
            ...this.endpoint,
            filter: this.filter
        })).then(response => {
            loadings.data = false;

            this.setState({
                dataActives: response.data,
                totalActives: response.total,
                loadings
            });


        })
            .catch(error => {

                loadings.data = false;

                this.setState({
                    loadings
                });
            })
    }

    getDataArchive = () => {

        let { loadings } = this.state;
        loadings.data = true;

        this.setState({ loadings });

        this.props.dispatch(actions.definitions.getData({
            ...this.endpointArchive,
            filter: this.filter
        })).then(response => {
            loadings.data = false;

            this.setState({
                dataArchives: response.data,
                totalArchives: response.total,
                loadings
            });


        })
            .catch(error => {

                loadings.data = false;

                this.setState({
                    loadings
                });
            })
    }

    onChangeSearchbox = (e) => {

        this.filter.query = e.target.value;

        if (e.target.value.length > 2) {
            clearTimeout(searchTimeout);
            searchTimeout = setTimeout(() => {
                this.getData(true);
            }, 500);
        } else {
            this.getData(true);
        }


    }

    onChangeSort = (value) => {
        this.filter.sortdirection = value;
        this.getData(true);
    }

    onDeleteConfirm = (id) => {

        let _this = this;
        let endpoint = { keyOne: `${type}`, idOne: id };

        confirm({
            centered: true,
            title: 'Adres Silme',
            icon: <ExclamationCircleOutlined />,
            content: 'Bu işlem bir daha geri alınamaz.',
            okText: "Sil",
            okType: "danger",
            onOk() {
                _this.props
                    .dispatch(
                        actions.definitions["deleteData"]({
                            ...endpoint,
                        })
                    )
                    .then((response) => {
                        _this.getData()
                        Notification.success({
                            message: errorMessageNotification(response),
                            className: "general-notification",
                            placement: "bottomLeft",
                            duration: 3,
                        });
                    }

                    );
            },
            onCancel() {
            },
        });

    }

    render() {

        let { loadings, dataActives, dataArchives, totalArchives, totalActives } = this.state;

        return (

            <Fragment>
                {
                    loadings.data &&
                    <div className="ant-loading loading-content">
                        <Spin
                            tip={`${i18n.t(`loading`, {
                                lng: this.props.currentLanguage,
                            })}`}
                        />
                    </div>
                }

                {
                    !loadings.data &&
                    <div className='list-container trips'>

                        {
                            dataActives.length > 0 &&

                            <div className='page-header'>
                                <Row>
                                    <Col xs={16} sm={16} md={16} lg={16} xl={16}>
                                        <h1>
                                            <span className='count background-yellow'>{totalActives}</span>
                                            <span className='label'>Onayınızı bekleyen talebiniz bulunmaktadır</span>
                                        </h1>
                                    </Col>
                                </Row>
                            </div>

                        }

                        <List
                            className='content-list'
                            grid={{
                                gutter: 16,
                                xs: 3,
                                sm: 3,
                                md: 3,
                                lg: 3,
                                xl: 3,
                                xxl: 3,
                            }}
                            locale={{
                                emptyText: <Empty
                                    image={Empty.PRESENTED_IMAGE_DEFAULT}
                                    imageStyle={{
                                        height: 60,
                                    }}
                                    description={
                                        <span>
                                            Onay bekleyen seyahat bulunmuyor!
                                        </span>
                                    }
                                >
                                </Empty>
                            }}
                            dataSource={dataActives}
                            renderItem={(item) => (

                                <Badge.Ribbon text="Daha önce itiraz edildi" color="red" style={{ right: 0, display: `${item.isObjected ? "block" : "none"}` }} >
                                    <List.Item>
                                        {
                                            item.isNew ?

                                                <Card
                                                    hoverable
                                                    title={item.title}
                                                    className='new-item-trip'
                                                    onClick={() => this.props.history.push(`/app/trips/create`)}
                                                >
                                                    <div><CarOutlined /></div>

                                                </Card>
                                                :
                                                <div className='item-detail item-detail-yellow'
                                                    onClick={() => this.props.history.push(`/app/tripapprovals/${item.id}`)}
                                                >

                                                    <p className='date'>
                                                        {moment.parseZone(item.departureDate).format('DD MMMM YYYY')}

                                                    </p>
                                                    <p className='day'>
                                                        {moment.parseZone(item.departureDate).format('dddd')}

                                                    </p>
                                                    <p className='date'>
                                                        {moment.parseZone(item.departureDate).format('LT')}
                                                    </p>
                                                    <p className='subject mt-20'>
                                                        Durumu
                                                    </p>
                                                    <p className='description'>
                                                        {item.statusText}
                                                    </p>
                                                    <p className='subject'>
                                                        {item.startPoint.shortAddress}
                                                    </p>
                                                    <p className='description' style={{ minHeight: 32 }}>
                                                        {item.startPoint.address}                                                </p>
                                                    <p className='subject'>
                                                        {item.endPoint.shortAddress}
                                                    </p>
                                                    <p className='description' style={{ minHeight: 32 }}>
                                                        {item.endPoint.address}
                                                    </p>
                                                    <p className='subject'>
                                                        Talep No
                                                    </p>
                                                    <p className='description'>
                                                        #{item.id}
                                                    </p>

                                                </div>
                                        }
                                    </List.Item>
                                </Badge.Ribbon>
                            )}
                        />

                    </div>
                }
                {
                    !loadings.data &&
                    <div
                        className='list-container trips'
                    >
                        <div className='page-header'>
                            <Row>
                                <Col xs={8} sm={8} md={8} lg={8} xl={8}>
                                    <h1>
                                        <span className='count-black'>{totalArchives}</span>
                                        <span className='label'>Talebiniz Arşivlenmekte</span>
                                    </h1>
                                </Col>
                            </Row>
                        </div>

                        <List
                            className='content-list'
                            grid={{
                                gutter: 16,
                                xs: 3,
                                sm: 3,
                                md: 3,
                                lg: 3,
                                xl: 3,
                                xxl: 3,
                            }}
                            dataSource={dataArchives}
                            locale={{
                                emptyText: <Empty
                                    image={Empty.PRESENTED_IMAGE_DEFAULT}
                                    imageStyle={{
                                        height: 60,
                                    }}
                                    description={
                                        <span>
                                            Arşivlenen seyahat bulunmuyor!
                                        </span>
                                    }
                                >
                                </Empty>
                            }}

                            renderItem={(item) => (
                                <Badge.Ribbon text="Daha önce itiraz edildi" color="red" style={{ right: 0, display: `${item.isObjected ? "block" : "none"}` }} >

                                    <List.Item
                                    >
                                        {
                                            item.isNew ?

                                                <Card
                                                    hoverable
                                                    title={item.title}
                                                    className='new-item-trip'
                                                    onClick={() => this.props.history.push(`/app/trips/create`)}
                                                >
                                                    <div><CarOutlined /></div>

                                                </Card>
                                                :
                                                <div className='item-detail item-detail-black'
                                                    onClick={() => this.props.history.push(`/app/tripapprovals/${item.id}`)}

                                                >

                                                    <p className='date'>
                                                        {moment.parseZone(item.departureDate).format('DD MMMM YYYY')}

                                                    </p>
                                                    <p className='day'>
                                                        {moment.parseZone(item.departureDate).format('dddd')}

                                                    </p>
                                                    <p className='date'>
                                                        {moment.parseZone(item.departureDate).format('LT')}
                                                    </p>
                                                    <p className='subject mt-20'>
                                                        Durumu
                                                    </p>
                                                    <p className='description'>
                                                        {item.statusText}
                                                    </p>
                                                    <p className='subject'>
                                                        {item.startPoint.shortAddress}
                                                    </p>
                                                    <p className='description' style={{ minHeight: 32 }}>
                                                        {item.startPoint.address}                                                </p>
                                                    <p className='subject'>
                                                        {item.endPoint.shortAddress}
                                                    </p>
                                                    <p className='description' style={{ minHeight: 32 }}>
                                                        {item.endPoint.address}
                                                    </p>
                                                    <p className='subject'>
                                                        Talep No
                                                    </p>
                                                    <p className='description'>
                                                        #{item.id}
                                                    </p>

                                                </div>

                                        }
                                    </List.Item>
                                </Badge.Ribbon>
                            )}
                        />
                    </div>
                }
            </Fragment >

        );
    }
}

const mapStateToProps = ({ account }) => ({ ...account });
export default connect(mapStateToProps)(TripApprovalList);


// WEBPACK FOOTER //
// ./src/components/App/Views/TripApproval/TripApprovalList.js